import { Stack, Typography } from '@mui/material';
import { isMobile } from 'react-device-detect';
import { motion } from "framer-motion";


export const WemeInvite = () => {
    return (
        <Stack
            position="absolute"
            top="5%"
            alignItems="center"
            height={isMobile ? "10vh" : "100%"}
            width="80%"
            alignSelf="center"
            gap={isMobile ? undefined : "4vh"}
            justifyContent={isMobile ? undefined : "center"}
            direction={isMobile ? "row" : "column"}
        >
            <motion.img
                animate={isMobile ? { scale: 0.6, y: ["32vh", "0vh"], x: ["-24vw", "0vw"] } : { x: ["-24vw", "0vw"] }}
                transition={isMobile ? { duration: 1.2 } : { duration: 1 }}
                className="weme-invite-icon"
                src="/weme-logo-white.png"
                alt="WEME icon"
            />
            <motion.div
                className="weme-invite-text"
                initial={{ opacity: 0 }}
                animate={{ x: ["-50vw", "0vw"], opacity: 1 }}
                transition={{ duration: 1.2 }}
             />
        </Stack>
    );
};
